import { useEffect, useState } from 'react';

import BreadcrumbTwo from '../../../components/Breadcrumbs/BreadcrumbTwo';
import ProductSubCategoryTable from '../../../components/Catalog/subCategories/ProductSubCategoryTable';
import ProductSubCategoryPopup from '../../../components/Catalog/subCategories/ProductSubCategoryPopup';
import EditProductSubCategoryPopup from '../../../components/Catalog/subCategories/EditProductSubCategoryPopup';

import DefaultLayout from '../../../layout/DefaultLayout';

import { useProductCategories } from '../../../hooks/useProductCategories';
import { useProductSubCategories } from '../../../hooks/product/useProductSubCategories';
import SimpleSearchSelect from '../../../components/Forms/Input/SimpleSearchSelect';
import SectionWrapper from '../../../components/SectionWrapper/SectionWrapper';

const ProductSubCategoryPage = () => {
  const { fetchProductCategoriesDropdown, productCategoriesDropdown } =
    useProductCategories();

  const {
    subCategories,
    loadSubCategoriesByCategory,
    toggleSubCategoryStatus,
    saveSubCategory,
  } = useProductSubCategories();

  const [selectedCategoryId, setSelectedCategoryId] = useState<number>(0);

  const [selectedCategoryName, setSelectedCategoryName] = useState('');

  const [popupOpen, setPopupOpen] = useState(false);

  const [editPopupOpen, setEditPopupOpen] = useState(false);

  const [selectedSubCategory, setSelectedSubCategory] = useState<any>(null);

  useEffect(() => {
    fetchProductCategoriesDropdown();
  }, []);

  const handleEdit = (subCategory: any) => {
    setSelectedSubCategory({
      ...subCategory,
      categoryId: selectedCategoryId,
      categoryName: selectedCategoryName,
    });

    setEditPopupOpen(true);
  };

  return (
    <DefaultLayout>
      <BreadcrumbTwo />

      <SectionWrapper>
        <div className="p-6">
          <SimpleSearchSelect
            label="Categoría"
            name="category"
            options={productCategoriesDropdown}
            selectedValue={selectedCategoryId}
            iconKey="search"
            onSelect={(category) => {
              setSelectedCategoryId(category.id);
              setSelectedCategoryName(category.name);
              loadSubCategoriesByCategory(category.id);
            }}
            rightButton={
              <button
                onClick={() => setPopupOpen(true)}
                disabled={!selectedCategoryId}
                className="
        h-12.5
        rounded-r-md
        bg-primary
        px-5
        text-white
        transition
        hover:bg-opacity-90
        disabled:cursor-not-allowed
        disabled:opacity-50
      "
              >
                Agregar Subcategoría
              </button>
            }
          />

          <ProductSubCategoryTable
            subCategories={subCategories}
            onEdit={handleEdit}
            onToggleStatus={toggleSubCategoryStatus}
          />
        </div>
      </SectionWrapper>

      <ProductSubCategoryPopup
        popupOpen={popupOpen}
        setPopupOpen={setPopupOpen}
        categoryId={selectedCategoryId}
        categoryName={selectedCategoryName}
        onRegister={saveSubCategory}
      />

      <EditProductSubCategoryPopup
        popupOpen={editPopupOpen}
        setPopupOpen={setEditPopupOpen}
        selectedSubCategory={selectedSubCategory}
        onUpdate={saveSubCategory}
      />
    </DefaultLayout>
  );
};

export default ProductSubCategoryPage;
